import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
    selector: "[appCardFormatting]",
    standalone: false
})
export class CardFormattingDirective {
  constructor(private el: ElementRef) {}

  @HostListener("input", ["$event"]) onInputChange(event: any) {
    const input = event.target;
    let trimmed = input.value.replace(/\s+/g, "");
    let numbersOnly = trimmed.replace(/\D/g, ""); // Remove non-numeric characters
    const maxLength = 19; // Maximum length for card numbers

    if (numbersOnly.length > maxLength) {
      numbersOnly = numbersOnly.substr(0, maxLength);
    }

    const formattedNumbers = [];
    for (let i = 0; i < numbersOnly.length; i += 4) {
      if (i + 4 <= maxLength) {
        formattedNumbers.push(numbersOnly.substr(i, 4));
      } else {
        formattedNumbers.push(numbersOnly.substr(i));
      }
    }

    input.value = formattedNumbers.join(" ");
  }
}
